<template>
    <div class="clearfix">
        <a-upload
            action="//etakeaway"
            listType="picture-card"
            :fileList="fileList"
            :beforeUpload="beforeUpload"
            @preview="handlePreview"
            @change="handleChange"
            :remove="handleRemove"
        >
            <div v-if="fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
            </div>
            <!-- <img v-else class="image-uploader"  :src="imageUrl" /> -->
            
        </a-upload> 
        
        <!--Preview image section -->
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
    </div>
</template>

<script>
export default {
    name: 'ImageUploader',
    props: {
        imageUrl : { type: String }
    },
    data () {
        return {
            previewVisible: false,
            previewImage: '',
            fileList: []
        }
    },
    methods: {
        
        handleCancel () {
            this.previewVisible = false
        },
        handlePreview (file) {
            this.previewImage = file.url || file.thumbUrl
            this.previewVisible = true
        },
        handleChange ({ fileList }) {
            fileList.pop();
            this.fileList = fileList;
        },

        handleRemove() {
            this.$emit('remove', {});
        },

        clear() {
            this.fileList = [];
        },

        beforeUpload(file) {
            this.$emit('ready-upload', file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                let newFile = {
                    uid : file.uid,
                    name: file.name,
                    status: 'done',
                    url: reader.result
                };
                this.fileList = [...this.fileList, newFile];
            };
            
            return false;
        }
    },
    created() {
        
        if (this.imageUrl != null || this.imageUrl != '') {
            let newFile = {
                uid : '-1',
                name: 'none.jpg',
                status: 'done',
                url: this.imageUrl
            };
            this.fileList.push(newFile);
        }
    }
   
}
</script>

<style>
  /* you can make up upload button and sample style by using stylesheets */
  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
  }

  .image-uploader {
      max-width: 106px;
      max-height: 106px;
  }



</style>